﻿import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./StatusPanel.css";
import './EmployeeCircleStatus.css';
import './Status.css';

/**
 * @deprecated Use ActionPanel from components/panel instead.
 */
export function StatusPanel({ title, status, children, loading }) {
    const panelClass = classNames("status-panel-section", "status-panel", {
        resolved: status === "resolved",
        unresolved: status === "unresolved",
        none: status === "none",
    });

    return (
        <div className={panelClass}>
            <div className="status-panel-expanded">
                <div className={classNames({ "bp6-skeleton": loading }, "status-panel-title-row")}>
                    <strong>{title}</strong>
                </div>
                <div className="status-panel-content">
                    {children}
                </div>
            </div>
        </div>
    );
}

StatusPanel.propTypes = {
    title: PropTypes.string.isRequired,
    status: PropTypes.oneOf(["resolved", "unresolved", "none"]).isRequired,
    children: PropTypes.node.isRequired,
    loading: PropTypes.bool,
};
